import { getPublicConfig } from "@/shared/config/config"
import { AUTH_METHOD } from "@/shared/constants/authMethods"
import { getMsalInstance } from "@/shared/msal/loader"
import { logger } from "@/shared/utils/add/logger/logger"

export async function logout() {
  logger.debug("Logging out")

  const authMethod = window.localStorage.getItem("authMethod") as
    | typeof AUTH_METHOD.COOKIE
    | typeof AUTH_METHOD.MSAL
    | null

  if (authMethod === AUTH_METHOD.COOKIE) {
    try {
      const [{ createCookieTokenProvider }, { createHttpClient }] = await Promise.all([
        import("@/shared/api/auth/tokenProvider"),
        import("@/shared/api/http/httpClient")
      ])
      const httpClient = createHttpClient(createCookieTokenProvider())
      await httpClient.getWithoutRedirect<unknown>(`${getPublicConfig().cmApiBaseUrl}/auth/logout`)
      logger.debug("Cookie auth logout successful")
    } catch (error) {
      // If logout fails (e.g., not authenticated), just log and continue
      logger.debug("Cookie auth logout failed (may not be authenticated)", error)
    }
    return
  }

  const msalConfig = getMsalInstance()
  const { instance } = msalConfig
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0]

  if (account) {
    logger.debug("Logging out MSAL account", account)
    await instance.logoutRedirect({ account })
    return
  }
}
